export default {
  container: {
    width: '100%',
    backgroundColor: 'tmWhite',
    mt: ['0', '20px'],
    mb: ['0', '0px'],

    '.react-player__preview, .videoPlayer': {
      borderRadius: '8px',
      width: ['100% !important', '100% !important', '550px !important'],
      maxWidth: ['', '', '550px !important'],
      maxHeight: ['100% !important', '100% !important', '300px !important'],
    },
    video: {
      borderRadius: '8px',
      width: ['100%! important', '100% !important', '550px !important'],
    },
  },

  carouselImage: {
    borderRadius: '10px 10px 10px 0px',
    minHeight: '100%',
    width: '80%',
    objectFit: 'cover',
  },
  sliderWrap: {
    margin: ['0 auto', '0 auto', ''],
    '.swiper': {
      width: ['100%', '100%', '100%'],
      height: '100%',
    },
    '.swiper-slide': {
      textAlign: 'center',
      fontSize: '18px',
      maxWidth: '100%',
      width: ['100% !important', '100% !important', ''],
      maxHeight: ['', '', '330px'],
      '& > div': {
        width: ['100vw !important', '100vw !important', '550px !important'],
        height: ['100% !important', '100% !important', '300px !important'],
        margin: '0 auto',
        aspectRatio: ['2 / 1', ''],
      },
      background: 'transparent',
      display: 'flex',
      WebkitBoxPack: 'center',
      MsFlexPack: 'center',
      WebkitJustifyContent: 'center',
      justifyContent: 'center',
      WebkitBoxAlign: 'center',
      MsFlexAlign: 'center',
      WebkitAlignItems: 'center',
      alignItems: 'center',
    },

    '.swiper-slide img': {
      display: 'block',
      width: ['100%', '550px'],
      height: ['100%', '300px'],
      objectFit: 'cover',
      position: 'relative',
      borderRadius: '10px 10px 10px 0px',
    },
    '.swiper-pagination': {
      position: 'relative',
      bottom: '0px',
      marginTop: ['20px', '37px', '39px'],
    },
    '.swiper-pagination-bullet': {
      background: 'tmBlue',
      width: ['10px', '10px', '15px'],
      height: ['10px', '10px', '15px'],
      margin: '0 15px!important',
    },
    '.swiper-pagination-bullet-active': {
      background: '#D31345',
    },
  },
  videoTitle: {
    color: 'tmBlueV3',
    fontWeight: 900,
    fontSize: ['1.2rem', '1.4rem'],
    py: ['12px', '40px'],
    px: ['30px', '80px'],
    fontFamily: 'spoqaRegular',
  },
  videoPlay: {
    position: 'absolute',
  },
}
